import React from 'react';
import "./PageHeader.css";

const PageHeader = ({
    title,
    slogan
}) => {
    return (
        <div className="pagehero-header">
            <div className="pagehero-background">
                <span className="pagehero-line pagehero-line-1"></span>
                <span className="pagehero-line pagehero-line-2"></span>
                <span className="pagehero-line pagehero-line-3"></span>
                <span className="pagehero-line pagehero-line-4"></span>
                <span className="pagehero-line pagehero-line-5"></span>
            </div>

            <div className="pagehero-contentWrapper">
                <div className="pagehero-content">
                    <h1 className="pagehero-title">
                        {title}
                    </h1>

                    {slogan && (
                        <p className="pagehero-slogan">
                            {slogan}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PageHeader;